export const MyStyle = [
    {
      "stylers": [
        {
          "saturation": -100
        }
      ]
    }
  ]